<template>
  <div class="time-picker"
       @click.stop="onOpen($event)"
       v-clickoutside="handleClose"
       :class="{z2:selectedTime.show}">
    <div class="timeInput" >
      <input ref="input" type="text" v-model="selectedTime.time" readonly="readonly">
      <i class="fa fa-clock-o"></i>
    </div>

    <div
            class="box"
            ref="panel"
            @mousemove="onMousemove"
            v-show="selectedTime.show"
            :style="dropdownXY"
    >
      <section>
        <div>
          <ol class="hours" ref="hours" @mousewheel="onMousewheel($event, 'hours')">
            <li v-for="(item, index) in data.hoursList"
                :class="{
                active: index == data.hours,
                disabled: index >= selectedTime.startRange && index <= selectedTime.endRange
              }">{{_preFixInterge(index)}}</li>
          </ol>
        </div>
        <div>
          <ol class="minutes" ref="minutes"  @mousewheel="onMousewheel($event, 'minutes')">
            <li v-for="(item, index) in data.minutesList"
                :class="{active: index == data.minutes}">{{_preFixInterge(index)}}</li>
          </ol>
        </div>
        <div>
          <ol class="seconds" ref="seconds"  @mousewheel="onMousewheel($event, 'seconds')">
            <li v-for="(item, index) in data.secondsList"
                :class="{active: index == data.seconds}">{{_preFixInterge(index)}}</li>
          </ol>
        </div>
      </section>
      <footer @click.stop>
        <mc-btn size="small" @click="onConfirm">确定</mc-btn>
        <mc-btn type="assist" size="small" @click="onCancel">取消</mc-btn>
      </footer>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
    /**
     * 获取给定元素的 CSS 计算属性
     * @function
     * @ignore
     * @argument {Eement} element 给定的元素
     * @argument {String} property 属性
     */
    function getStyleComputedProperty(element, property) {
        // 注：这里会访问 DOM
        var css = window.getComputedStyle(element, null);
        return css[property];
    }
    /**
     * 返回给定元素用来计算滚动的父元素
     * @function
     * @ignore
     * @argument {Element} element
     * @returns {Element} scroll parent
     */
    function getScrollParent(element) {
        var parent = element.parentNode;

        if (!parent) {  // 没有父级
            return element;
        }

        if (parent === window.document) {
            // Firefox 会将 scrollTop的判断放置的 `documentElement` 而非 `body` 上
            // 我们将判断二者谁大于0来返回正确的元素
            if (window.document.body.scrollTop) {
                return window.document.body;
            } else {
                return window.document.documentElement;
            }

        }

        // Firefox 要求我们也要检查 `-x` 以及 `-y`
        if (
            ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow')) !== -1 ||
            ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-x')) !== -1 ||
            ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-y')) !== -1
        ) {
            // 如果检测到的 scrollParent 是 body，我们将对其父元素做一次额外的检测
            // 这样在 Chrome 系的浏览器中会得到 body，其他情况下会得到 documentElement
            // 修复 issue #65
            return parent;
        }
        return getScrollParent(element.parentNode);
    }

    export default {
        name: 'TimePicker',
        props:{
            selectedTime: {
                type: Object,
                default: () => {
                    return {
                        hours       : 0,
                        minutes     : 0,
                        seconds     : 0,
                        time        : '',
                        startRange  : 'start',
                        endRange    : 'end',
                        show        :false,
                    }
                }
            }
        },
        data() {
            return {
                rect: {
                    bottom  : 0,
                    left    : 0,
                    width   : 0
                },
                data        : {
                    hoursList   : 24,
                    minutesList : 60,
                    secondsList : 60,
                    // 判断 Mac 平台，用来解决Mac下滚动加速度问题
                    isMacWebkit : (navigator.userAgent.indexOf("Macintosh") !== -1 &&
                        navigator.userAgent.indexOf("webKit") !== -1),
                    hours       : 0,
                    minutes     : 0,
                    seconds     : 0,
                    hoursY      : 0,          // Y坐标, 如指定，必须 <= 0,
                    minutesY    : 0,
                    secondsY    : 0,
                    frameheight : 150        // 容器高度
                },
                show        : false,
                focuseHours : this._preFixInterge(this.selectedTime.hours),

            }
        },
        computed: {
            // 下拉框坐标
            dropdownXY() {
                return {
                    top   : this.rect.bottom + 'px',
                    left  : this.rect.left + 'px',
                    width : this.rect.width + 'px'
                }
            }
        },
        watch: {
            selectedTime: {
                deep: true,
                handler(val){
                    this.resiet(val);
                    this.selectedTime.time = this.inputData(this.selectedTime);
                }
            }

        },
        mounted(){
            // this.resiet(this.selectedTime);             // 初始化坐标
            this.selectedTime.time = this.inputData(this.selectedTime);    // 初始化时间字符串

            // let _this = this;
            // let _DOM = document.getElementById(this.id)
            // window.addEventListener('click',events)
            //
            // function events(e) {
            //     let ev = e || window.event;
            //     if(ev.target.id !== _DOM.id) {
            //         _this.selectedTime.show = false;
            //     }
            // }
        },
        beforeDestroy(){

        },
        directives: {
            clickoutside: {
                bind(el, binding, vnode) {
                    function documentHandler(e) {
                        if (el.contains(e.target)) {  // 判断点击区域是否是指令所在的元素内部
                            return false;               // 是 则跳出函数
                        }

                        if (binding.expression) {     // 判断当前指令（v-clickoutside），是否写了表达式（应为函数
                            binding.value(e);           // 执行指令绑定的函数，即 _handleClose
                        }
                    }
                    function resetRect() {
                        // 修正dropdown坐标
//            vnode.context.rect = el.getBoundingClientRect();
                        vnode.context.resitRect();
                    }

                    el.__vueClickOutside__ = documentHandler;
                    el.__vueScroll__ = resetRect;
                    document.addEventListener('click', documentHandler);
                    document.addEventListener('scroll', el.__vueScroll__);
                    document.addEventListener('resize', el.__vueScroll__);

                },
                inserted(el){
                    let target = getScrollParent( el );
                    target.addEventListener('scroll', el.__vueScroll__);
                },
                unbind(el, binding) {
                    let target = getScrollParent( el );
                    target.removeEventListener('scroll', el.__vueScroll__);
                    document.removeEventListener('click', el.__vueClickOutside__);
                    document.removeEventListener('resize', el.__vueScroll__);
                    document.removeEventListener('scroll', el.__vueScroll__);

                    delete el.__vueClickOutside__;
                    delete el.__vueScroll__;

                }
            }
        },
        methods: {
            init() {

            },
            resitRect(){
                if(!this.selectedTime.show){ return; }
                this.$nextTick(()=>{
                    let panelRect = this.$refs.panel.getBoundingClientRect();
                    let windowH = window.innerHeight;
                    let inputRect = this.$refs.input.getBoundingClientRect();

                    // console.log('>>>>>>', panelRect)

                    if( (windowH - inputRect.bottom) > panelRect.height ) {
                        // console.log('显示在下方')
                        this.rect = inputRect;
                    }else{
                        // console.log('显示在上方 ' );
                        this.rect = {
                            bottom  : inputRect.top - panelRect.height,
                            left    : inputRect.left,
                            width   : inputRect.width
                        }
                    }
                })
            },
            // 关闭下拉
            handleClose() {
                this.selectedTime.show = false;
            },
            // 返回 拼接时间字符串
            inputData (data) {
                let hours = this._preFixInterge(data.hours);
                let minutes = this._preFixInterge(data.minutes);
                let seconds = this._preFixInterge(data.seconds);

                return `${hours}:${minutes}:${seconds}`
            },
            _preFixInterge(num,n = 2){
                //num 传入的数字，n 要保留的长度
                return (Array(n).join(0)+num).slice(-n);
            },
            // 初始化时间
            resiet(val){
                // 初始化小时
                if(val.hours >= 0){
                    this.data.hours = val.hours
                    this.data.hoursY = -val.hours * 30
                    this.$refs['hours'].style.top = `${this.data.hoursY}px`;
                }
                // 初始化分钟
                if(val.minutes >= 0){
                    this.data.minutes = val.minutes
                    this.data.minutesY = -val.minutes * 30
                    this.$refs['minutes'].style.top = `${this.data.minutesY}px`;
                }
                // 初始化秒
                if(val.seconds >= 0){
                    this.data.seconds = val.seconds
                    this.data.secondsY = -val.seconds * 30
                    this.$refs['seconds'].style.top = `${this.data.secondsY}px`;
                }
            },
            onConfirm() {
                this.selectedTime.hours = this.data.hours
                this.selectedTime.minutes = this.data.minutes
                this.selectedTime.seconds = this.data.seconds

                // 禁用范围，需在优化
                // if(this.data.hours < this.selectedTime.startRange || this.data.hours > this.selectedTime.endRange) {
                //     this.selectedTime.hours = this.data.hours
                //     this.selectedTime.minutes = this.data.minutes
                //     this.selectedTime.seconds = this.data.seconds
                // }
                this.selectedTime.time = this.inputData(this.selectedTime);
                this.selectedTime.show = false;
                console.log('onConfirm>>>>>>', this.selectedTime)
            },
            onOpen(e){
                this.$emit('openTimeBox')
                this.selectedTime.show = true;
                this.resitRect();
//
            },
            onCancel(){
                this.selectedTime.time = this.inputData(this.selectedTime);
                this.selectedTime.show = false;
                console.log( this.selectedTime.show)

            },
            onMousemove() {
                this.resiet(this.data);
            },
            onMousewheel(e, focus) {

                var deltaY =  e.deltaY*-30 ||                                     // wheel 事件
                    e.wheelDeltaY/4 ||                                  // webkit中的mousewheel事件
                    (e.wheelDeltaY === undefined && e.wheelDelta/4) ||  // 如无2D属性, 就用1D属性
                    0;                                                  // 属性未定义

                if(this.data.isMacWebkit) {
                    deltaY /= 30  // 修正 Mac 滚轮加速度

                }

                deltaY = Math.floor(deltaY / 120)   // 修正 滚轮偏移

                this.scrollFocus(deltaY, focus);


                // 阻止冒泡
                if(e.preventDefault) {
                    e.preventDefault();
                }
                if(e.stopPropagation){
                    e.stopPropagation();
                }
                return false;

            },
            scrollFocus(deltaY, focus) {
                var content       = this.$refs[focus];                          // DOM
                var contentBox    = content.getBoundingClientRect();            // DOM属性
                var contentHeight = contentBox.bottom - contentBox.top;         // DOM高

                var minoffset = Math.min(this.data.frameheight - contentHeight, 0);         // 容器高 减 DOM高 ＝ 可滚动范围 （负值）
                this.data[focus+'Y'] = Math.max(this.data[focus+'Y'] + deltaY, minoffset);  // 小于 minoffset
                this.data[focus+'Y'] = Math.min(this.data[focus+'Y'], 0);                   // 大于 0

                content.style.top = `${this.data[focus+'Y']}px`;                            // 定位DOM

                var activeNum = this.data[focus+'List'] - Math.round((contentHeight - 120 + this.data[focus+'Y']) / 30 )    // 计算active下标

                this.data[focus] = activeNum                  // 选中时间

                //this.selectedTime.time = this.inputData(this.data);

            }

        }

    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .time-picker{
    position: relative;
    /*z-index: 1;*/
    &.z2{
      z-index: 2;
    }
    .timeInput{
      position: relative;
      width: 100%;
      input{
        font-size: 14px;
        padding: 5px 5px;
        user-select: none;
        outline: none;
        color: #999;
        width: 100%;
      }
      i{
        position: absolute;
        display: block;

        top: 0px;
        right: 8px;
        font-size: 14px;
        color: #666;
        border-left:solid 1px #ccc;
        padding-left: 8px;
        height: 100%;
        line-height: 28px;
      }
    }


    .box{
      background-color: #fff;
      margin-top: -1px;
      width: 100%;
      height: 200px;
      border:solid 1px #ccc;
      box-shadow: 1.5px 2px 9px 0px rgba(4, 0, 0, .1);
      position: fixed;
      z-index: 1;
      &:before{
        clear: both;
        height: 30px;
        width: 100%;
        content: '';
        overflow: hidden;
        background-color: rgba(0, 150, 136, .1);
        position: absolute;
        left: 0;
        z-index: 0;
        top:60px;
      }
      &:after{
        clear: both;
        height: 1px;
        overflow: hidden;
        display: block;
        width: 100%;
      }
      section{
        display: block;
        box-sizing: border-box;
        width: 100%;
        padding: 0 8%;
        clear: both;
        overflow: hidden;
        div{
          z-index: 1;
          width: 33.3%;
          height: 150px;
          float: left;
          overflow: hidden;

          ol{
            width: 100%;
            display: inline-block;
            position: relative;
            top:0;
            &:before,&:after{
              height: 60px;
              display: block;
              content: '';
              overflow: hidden;
            }
            li{
              width: 100%;
              height: 30px;
              line-height: 30px;
              font-size: 12px;
              color: #999;
              overflow: hidden;
              text-align: center;
              user-select: none;
              font-weight: normal;
              &.active{
                font-size: 14px;
                font-weight: bold;
                color:rgba(0, 150, 136, 1);
              }
              &.disabled{
                color: #ccc !important;
              }
              &.disabled:hover{
                cursor: no-drop;
              }

            }
          }
        }
      }

      footer{
        &:before{
          clear: both;
          height: 1px;
          overflow: hidden;
          display: block;
          width: 100%;
        }
        margin-top: 10px;
        background-color: #fff;
        text-align: right;
        padding: 5px 10px;
        border-top: solid 1px #ccc;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/base-timepicker.vue